var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStarLeft(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 43.781,
    height: 42.517,
    viewBox: "0 0 43.781 42.517",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Polygon_3",
    "data-name": "Polygon 3",
    d: "M16.449,3.5a2,2,0,0,1,3.565,0l3.5,6.872a2,2,0,0,0,1.469,1.068l7.612,1.209a2,2,0,0,1,1.1,3.388L28.243,21.5a2,2,0,0,0-.56,1.725l1.2,7.625A2,2,0,0,1,26,32.944l-6.863-3.5a2,2,0,0,0-1.817,0l-6.863,3.5A2,2,0,0,1,7.576,30.85l1.2-7.625a2,2,0,0,0-.56-1.725L2.768,16.038a2,2,0,0,1,1.1-3.388l7.612-1.209a2,2,0,0,0,1.469-1.068Z",
    transform: "translate(0 8.821) rotate(-14)",
    fill: "#fed84b"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStarLeft);
export default __webpack_public_path__ + "static/media/star_left.bcbe81ed9258e8b48133c0bf33dc7015.svg";
export { ForwardRef as ReactComponent };